@if (field) {
    <div [class.hidden]="field.visible === false">
        <div class="form-group" [class.inline]="inline">
            <label for="{{ field.id }}" class="form-label mr-3">
                {{ field.title }}
                @if (field.unit) {
                    <span class="units">{{ field.unit }}</span>
                }
            </label>
            @if (loading) {
                <div class="form-field">
                    <div class="border p-2">
                        <kui-loader size="small"></kui-loader>
                    </div>
                </div>
            }
            @if (errorMessage) {
                <div class="form-field">
                    <div class="text-danger border p-2">{{ errorMessage }}</div>
                </div>
            }
            @if (!loading && !errorMessage) {
                <div class="form-field" [class.field-align-right]="field.type === 'toggle' || field.type === 'color' || field.type === 'radio' || field.type === 'swatches'">
                    <div class="d-flex">
                        <div [class]="field.type !== 'swatches' && field.type !== 'color' ? 'flex-1' : ''">
                            @switch (field.type) {
                                @case ("text") {
                                    <key-form-builder-text-field
                                        #fieldComponent
                                        [field]="field"
                                        [values]="values"
                                        [error]="error"
                                        (onChange)="emitFieldChange($event?.dirty)"
                                    ></key-form-builder-text-field>
                                }
                                @case ("password") {
                                    <key-form-builder-text-field
                                        #fieldComponent
                                        [field]="field"
                                        [values]="values"
                                        [error]="error"
                                        (onChange)="emitFieldChange($event?.dirty)"
                                    ></key-form-builder-text-field>
                                }
                                @case ("number") {
                                    <key-form-builder-number-field
                                        #fieldComponent
                                        [field]="field"
                                        [values]="values"
                                        [error]="error"
                                        (onChange)="emitFieldChange($event?.dirty)"
                                    ></key-form-builder-number-field>
                                }
                                @case ("memo") {
                                    <key-form-builder-memo-field
                                        #fieldComponent
                                        [field]="field"
                                        [values]="values"
                                        [error]="error"
                                        (onChange)="emitFieldChange($event?.dirty)"
                                    ></key-form-builder-memo-field>
                                }
                                @case ("daytime") {
                                    <key-form-builder-daytime-field
                                        #fieldComponent
                                        [field]="field"
                                        [values]="values"
                                        [error]="error"
                                        (onChange)="emitFieldChange($event?.dirty)"
                                    ></key-form-builder-daytime-field>
                                }
                                @case ("datetime") {
                                    <key-form-builder-datetime-field
                                        #fieldComponent
                                        [field]="field"
                                        [values]="values"
                                        [error]="error"
                                        (onChange)="emitFieldChange($event?.dirty)"
                                    ></key-form-builder-datetime-field>
                                }
                                @case ("date") {
                                    <key-form-builder-datetime-field
                                        #fieldComponent
                                        [field]="field"
                                        [values]="values"
                                        [error]="error"
                                        (onChange)="emitFieldChange($event?.dirty)"
                                    ></key-form-builder-datetime-field>
                                }
                                @case ("time") {
                                    <key-form-builder-datetime-field
                                        #fieldComponent
                                        [field]="field"
                                        [values]="values"
                                        [error]="error"
                                        (onChange)="emitFieldChange($event?.dirty)"
                                    ></key-form-builder-datetime-field>
                                }
                                @case ("combo") {
                                    <key-form-builder-combo-field
                                        #fieldComponent
                                        [field]="field"
                                        [values]="values"
                                        [error]="error"
                                        (onSelected)="comboChanged($event?.value, $event?.dirty)"
                                    ></key-form-builder-combo-field>
                                }
                                @case ("checkbox") {
                                    <key-form-builder-checkbox-field
                                        #fieldComponent
                                        [field]="field"
                                        [values]="values"
                                        [error]="error"
                                        (onChange)="emitFieldChange($event?.dirty)"
                                    ></key-form-builder-checkbox-field>
                                }
                                @case ("checklist") {
                                    <key-form-builder-checklist-field
                                        #fieldComponent
                                        [field]="field"
                                        [values]="values"
                                        [error]="error"
                                        (onChange)="emitFieldChange($event?.dirty)"
                                    ></key-form-builder-checklist-field>
                                }
                                @case ("tags") {
                                    <key-form-builder-tags-field
                                        #fieldComponent
                                        [field]="field"
                                        [values]="values"
                                        [error]="error"
                                        (onChange)="emitFieldChange($event?.dirty)"
                                    ></key-form-builder-tags-field>
                                }
                                @case ("assetfilter") {
                                    <key-form-builder-asset-filter-field
                                        #fieldComponent
                                        [field]="field"
                                        [error]="error"
                                        [values]="values"
                                        (onChange)="emitFieldChange($event?.dirty)"
                                    ></key-form-builder-asset-filter-field>
                                }
                                @case ("labelfilter") {
                                    <key-form-builder-label-filter-field
                                        #fieldComponent
                                        [field]="field"
                                        [error]="error"
                                        [values]="values"
                                        (onChange)="emitFieldChange($event?.dirty)"
                                    ></key-form-builder-label-filter-field>
                                }
                                @case ("searchselect") {
                                    <key-form-builder-search-select-field
                                        #fieldComponent
                                        [field]="field"
                                        [error]="error"
                                        [values]="values"
                                        (onChange)="searchSelectChanged($event?.dirty)"
                                    ></key-form-builder-search-select-field>
                                }
                                @case ("zonefilter") {
                                    <key-form-builder-zone-filter-field
                                        #fieldComponent
                                        [field]="field"
                                        [error]="error"
                                        [values]="values"
                                        (onChange)="emitFieldChange($event?.dirty)"
                                    ></key-form-builder-zone-filter-field>
                                }
                                @case ("clientfilter") {
                                    <key-form-builder-client-filter-field
                                        #fieldComponent
                                        [field]="field"
                                        [error]="error"
                                        [values]="values"
                                        (onChange)="emitFieldChange($event?.dirty)"
                                    ></key-form-builder-client-filter-field>
                                }
                                @case ("color") {
                                    <key-form-builder-color-field
                                        #fieldComponent
                                        [field]="field"
                                        [values]="values"
                                        [error]="error"
                                        (onChange)="emitFieldChange($event?.dirty)"
                                    ></key-form-builder-color-field>
                                }
                                @case ("colorcombo") {
                                    <key-form-builder-color-combo-field
                                        #fieldComponent
                                        [field]="field"
                                        [values]="values"
                                        [error]="error"
                                        (onSelected)="emitFieldChange($event?.dirty)"
                                    ></key-form-builder-color-combo-field>
                                }
                                @case ("toggle") {
                                    <key-form-builder-toggle-field
                                        #fieldComponent
                                        [field]="field"
                                        [values]="values"
                                        [error]="error"
                                        (onChange)="toggleChanged($event?.value, $event?.dirty)"
                                    ></key-form-builder-toggle-field>
                                }
                                @case ("radio") {
                                    <key-form-builder-radio-field
                                        #fieldComponent
                                        [field]="field"
                                        [values]="values"
                                        [error]="error"
                                        (onChange)="comboChanged($event?.value, $event?.dirty)"
                                    ></key-form-builder-radio-field>
                                }
                                @case ("minmax") {
                                    <key-form-builder-minmax-field
                                        #fieldComponent
                                        [field]="field"
                                        [values]="values"
                                        [error]="error"
                                        (onChange)="emitFieldChange($event?.dirty)"
                                    ></key-form-builder-minmax-field>
                                }
                                @case ("list") {
                                    <key-form-builder-list-field
                                        #fieldComponent
                                        [field]="field"
                                        [values]="values"
                                        [error]="error"
                                        (onChange)="emitFieldChange($event?.dirty)"
                                    ></key-form-builder-list-field>
                                }
                                @case ("eventfilter") {
                                    <key-form-builder-eventfilter-field
                                        #fieldComponent
                                        [field]="field"
                                        [values]="values"
                                        [error]="error"
                                        (onChange)="emitFieldChange($event?.dirty)"
                                    ></key-form-builder-eventfilter-field>
                                }
                                @case ("geofilter") {
                                    <key-form-builder-geofilter-field
                                        #fieldComponent
                                        [field]="field"
                                        [values]="values"
                                        [error]="error"
                                        (onChange)="emitFieldChange($event?.dirty)"
                                    ></key-form-builder-geofilter-field>
                                }
                                @case ("image") {
                                    <key-form-builder-image-field
                                        #fieldComponent
                                        [field]="field"
                                        [values]="values"
                                        [error]="error"
                                        (onChange)="emitFieldChange($event?.dirty)"
                                    ></key-form-builder-image-field>
                                }
                                @case ("swatches") {
                                    <key-form-builder-swatches-field
                                        #fieldComponent
                                        [field]="field"
                                        [values]="values"
                                        [error]="error"
                                        (onChange)="emitFieldChange($event?.dirty)"
                                    ></key-form-builder-swatches-field>
                                }
                                @case ("url") {
                                    <key-form-builder-text-field
                                        #fieldComponent
                                        [field]="field"
                                        [values]="values"
                                        [error]="error"
                                        pattern="^https?:\/\/.*"
                                        patternErrorMessage="FORMS.URL.INVALID_PATTERN"
                                        (onChange)="emitFieldChange($event?.dirty)"
                                    ></key-form-builder-text-field>
                                }
                            }
                        </div>
                        @if (field.actions && field.type !== "list" && field.type !== "tags") {
                            <div
                                [ngClass]="{
                                    'align-items-center': field.type !== 'swatches',
                                    'align-items-start': field.type === 'swatches',
                                    'pt-2': field.type === 'swatches',
                                }"
                                class="d-flex justify-content-center pl-2"
                            >
                                @for (action of field.actions; track action) {
                                    <kui-icon size="sm" kui-action [name]="action.icon" [kui-tooltip]="action.name" (click)="onActionClick(action)"> </kui-icon>
                                }
                            </div>
                        }
                    </div>

                    @if (field.description) {
                        <small class="form-text muted">
                            <markdown [data]="field.description"></markdown>
                        </small>
                    }
                </div>
            }
        </div>

        @for (subfield of subfields; track subfield) {
            <key-form-builder-field #subFieldComponent [inline]="inline" [field]="subfield" [values]="values" (onChange)="emitFieldChange($event?.dirty, subfield)">
            </key-form-builder-field>
        }
    </div>
}
